/**
 * tour-step-props.js
 */

const floaterProps = {
  styles: {
    floater: {
      filter: 'drop-shadow(rgba(0, 0, 0, 0.1) 0px 0px 5px)',
    },
  },
  disableAnimation: true,
  hideArrow: true,
};

export default {
  styles: {
    beacon: {
      zIndex: 1300,
    },
    options: {
      zIndex: 1300,
    },
  },
  floaterProps,
  disableBeacon: false,
  showSkipButton: true,
  spotlightClicks: false,
  locale: {
    back: 'Back',
    close: 'Close',
    last: 'End Tour',
    next: 'Next',
    open: 'Learn More',
    skip: 'Skip Tour',
  }
};
